import React from 'react'
import styled from 'styled-components'

const StyledPageWrapper = styled.div`
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 24px;
  max-width: 1080px;
`

interface PageWrapperProps {
  children: React.ReactNode
  testId?: string
}

const PageWrapper: React.FC<PageWrapperProps> = ({
  children,
  testId
}: PageWrapperProps) => {
  return <StyledPageWrapper data-testid={testId}>{children}</StyledPageWrapper>
}

export default PageWrapper
